import { createFileRoute } from '@tanstack/react-router';

import { AdminJobsPage } from '@/components/admin/jobs-page';
import { adminHead } from '@/lib/seo';
import { adminListJobsFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/jobs')({
    component: JobsRoute,
    head: () => adminHead('משימות רקע', '/admin/jobs'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListJobsFn({ data: { limit: 50 } }),
});

function JobsRoute() {
    const data = Route.useLoaderData();
    return <AdminJobsPage initial={data} />;
}
